import styled from 'styled-components'
import { flexbox, FlexboxProps, padding, PaddingProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<FlexboxProps>`
  display: flex;
  width: 100%;
  max-width: 1100px;
  border-radius: 20px;
  overflow: hidden;

  ${flexbox}
`

export const TitleHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${themeGet('space.11')}px ${themeGet('space.16')}px;
  background-color: ${themeGet('colors.background.screenContrast')};
`

export const ListHolder = styled.div.withConfig({
  shouldForwardProp,
})<PaddingProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-block: ${themeGet('space.11')}px;
  background-color: ${themeGet('colors.background.screenAlt')};
  gap: ${themeGet('space.8')}px;

  svg {
    flex-shrink: 0;
    color: ${themeGet('colors.primary.main')};
  }

  ${padding}
`

export const CallToHolder = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  padding: ${themeGet('space.11')}px 0;

  background-color: tomato;

  > img {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  p,
  button {
    z-index: 2;
  }
`

export const Overflow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${themeGet('colors.overlay.primaryAlt')};
  z-index: 1;
`
